export const agendaValues = {
    //  Time range the agenda displays by default (can be scrolledif not displayed anyway)
    slotMinTime:"00:00:00" ,
    slotMaxTime:"24:00:00"
  };